import { getCurrentUser } from '@/store/service'
import { configMercadopago, urlPayment } from '@/mercadopagoConfig'

import * as firebase from 'firebase'
require('firebase/firestore')

import axios from 'axios'

export const getDocById = (collection, id) => {
  return firebase.firestore().collection(collection).doc(id)
}

export const getPaymentApprovedByReference = reference => {
  let user = getCurrentUser()

  return (
    getPaymentByReference(reference)
    .then(payment => {
      if (!payment) {
        return null
      }
      let document = firebase.firestore().collection('users').doc(user.uid).collection('payments').doc(payment.id)
      return (
        document.get()
        .then(snapshot => {
          return {
            id: snapshot.id,
            ...snapshot.data()
          }
        })
      )
    })
    .catch(error => {
      console.log('ERROR', error.message)
    })
  )
}

export const savePaymentApproved = (reference, data) => {
  let user = getCurrentUser()
  return (
    getPaymentByReference(reference)
    .then(payment => {
      if (!payment) {
        return false
      }
      let document = firebase.firestore().collection('users').doc(user.uid).collection('payments').doc(payment.id)
      return (
        document.get()
        .then(snapshot => {
          let doc = snapshot.data()
          if (doc.response) {
            return true
          } else {
            return (
              document.update({
                response: data
              })
              .then(() => {
                return true
              })
              .catch(error => {
                throw error
              })
            )
          }
        })
      )
    })
    .catch(error => {
      console.log('ERROR', error)
    })
  )
}

export const getPaymentByReference = reference => {
  let user = getCurrentUser()
  let userObj = getDocById('users', user.uid)
  let document = firebase.firestore().collection('payments')
  let query = document.where('reference', '==', reference).where('user', '==', userObj)

  return (
    query
    .get()
    .then(result => {
      let payment = null
      result.forEach(doc => {
        let data = doc.data()
        payment = {
          id: doc.id,
          ...data
        }
      })
      return payment
    })
    .catch(error => {
      console.log('ERROR', error);
      throw error
    })
  )
}

export const createPreference = (user, value, reference, title) => {
  let back_url = window.location.origin + '/#/payment'
  let preference = {
    items: [{
      id: 'TTO',
      title: title,
      quantity: 1,
      currency_id: 'COP',
      category_id: 'others',
      unit_price: value
    }],
    payer: {
      name: user.displayName,
      email: user.email
    },
    back_urls: {
      success: back_url,
      failure: back_url,
      pending: back_url
    },
    auto_return: 'approved',
    notification_url: urlPayment.return_url + '?reference=' + reference,
    external_reference: reference
  }

  return (
    axios({
      method: 'post',
      url: urlPayment.preference_url,
      headers: {
        'Content-Type': 'application/json'
      },
      data: preference,
      params: {
        access_token: configMercadopago.access_token
      }
    })
    .then(response => {
      console.log('CREATED PREFERENCE:', preference, 'RESPONSE', response)
      return response
    })
    .catch(error => {
      console.log('ERROR CREATING PREFERENCE', error.message)
      console.log(error)
      throw error
    })
  )
}

export const createPayment = (plan, value, reference, next_payment) => {
  let user = getCurrentUser()
  let document = firebase.firestore().collection('payments').doc()

  return document
  .set({
    user: getDocById('users', user.uid),
    plan: getDocById('plans', plan.id),
    value: value,
    reference: reference,
    coverage_date: firebase.firestore.Timestamp.fromDate(new Date(next_payment)),
    created_at: firebase.firestore.FieldValue.serverTimestamp()
  })
  .then(() => {
    return document
  })
  .catch(error => {
    console.log('C', error)
    throw error
  })
}

export const getLastPayment = () => {
  let user = getCurrentUser()
  let reference = firebase.firestore().collection('users').doc(user.uid).collection('payments')
  let query = reference.orderBy('payment.created_at', 'desc').limit(1)

  return (
    query
    .get()
    .then(snapshots => {
      let invoice = null
      snapshots.forEach(snapshot => {
        invoice = {
          id: snapshot.id,
          ...snapshot.data()
        }
      })
      return invoice
    })
    .catch(error => {
      throw error
    })
  )
}

export const getInvoices = () => {
  let user = getCurrentUser()
  let reference = firebase.firestore().collection('users').doc(user.uid).collection('payments').orderBy('payment.created_at', 'desc')

  return (
    reference
    .get()
    .then(snapshots => {
      let invoices = []
      snapshots.forEach(snapshot => {
        invoices.push({
          id: snapshot.id,
          ...snapshot.data()
        })
      })

      return invoices
    })
    .catch(error => {
      throw error
    })
  )
}
